import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "@mantine/core";
import { AuthContext } from "../../../providers/AuthProvider";
import ToggleBulkAssigneeTagApiService from "../services/api/ToggleBulkAssigneeTagApiService";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type UnAssignTagActionButtonProps = {
  employees: number[];
  tagId: number;
};

const UnAssignTagButton: React.FC<UnAssignTagActionButtonProps> = ({
  employees,
  tagId,
}) => {
  const auth = useContext(AuthContext);
  const { showToast } = useToasts();
  const { isLoading, isError, error, isSuccess, mutate } =
    ToggleBulkAssigneeTagApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "unassign_tag_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({ strapiId: "unassign_tag_success" });
      queryClient.invalidateQueries(["TagsDetailsApiService", tagId]).then();
    }
  }, [isSuccess]);

  if (!auth) {
    return <Navigate replace to="/login" />;
  }

  return (
    <Button
      variant="outline"
      type="button"
      color="jem-theme"
      loading={isLoading}
      onClick={() =>
        mutate({
          tagId,
          employees,
          isTagged: false,
        })
      }
    >
      Remove
    </Button>
  );
};

export default UnAssignTagButton;
